import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useIntercom } from "react-use-intercom";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import usePaymentSource from "common/datahooks/usePaymentSource";
import usePromotions from "common/datahooks/usePromotions";

export default function useWorkspaceChangeUpdates() {
  const workspace = useSelectedWorkspaceContext();

  const {
    accounts,
    id: workspaceId,
    lifetime_license_count: workspaceLtdCount,
    subscription,
  } = workspace ?? {};

  const { paymentSource } = usePaymentSource(subscription?.id);
  const { ltdPromotion, appSumoPromotion } = usePromotions();

  const { update } = useIntercom();

  const totalLtdCount =
    (ltdPromotion?.license_count ?? 0) + (appSumoPromotion?.license_count ?? 0);

  useEffect(() => {
    if (workspace) {
      let paymentMethod = "No payment method";
      if (paymentSource) {
        paymentMethod =
          paymentSource.type === "card"
            ? `Card ending in ${paymentSource.card.last4}`
            : `Paypal email ${paymentSource.paypal.email}`;
      }

      const loggedOutAccountsCount = accounts.filter(
        (account) => account.state !== "LoggedIn",
      ).length;

      const loggedInAccountsCount = accounts.filter(
        (account) => account.state === "LoggedIn",
      ).length;

      update({
        customAttributes: {
          "Workspace ID": workspaceId,
          "Payment Method": paymentMethod,
          "LoggedOut accounts count": loggedOutAccountsCount,
          "LoggedIn accounts count": loggedInAccountsCount,
          "Workspace LTD Count": workspaceLtdCount,
          "Total LTD Count": totalLtdCount,
          ...(subscription && {
            "Subscription ID": subscription.id,
            "Subscription Status": subscription.status,
            "Next Billing Date": new Date(
              subscription.next_billing * 1000,
            ).toISOString(),
          }),
        },
      });
      Sentry.setTag("workspace id", workspaceId);
    }
  }, [
    workspaceId,
    paymentSource,
    subscription,
    workspaceLtdCount,
    accounts,
    totalLtdCount,
  ]);
}
